module.exports = __webpack_public_path__ + "static/media/cards-movements.b19bc8ef.png";